

































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class NotificationContainer extends Vue {
  @Prop() data!: [];
}
